// extracted by mini-css-extract-plugin
module.exports = {"fab":"About_fab__3e7mM","fas":"About_fas__3DTLD","about":"About_about__AswM6"};